export const PROD_DOMAIN = typeof window !== 'undefined' && window?.location?.origin.includes('exchange')
  ? 'https://exchange.homedepot.com'
  : 'https://www.homedepot.com';

export const FEATURE_SWITCHES = Object.freeze({
  isHideLimitedStockClearanceEnabled: 'fs:isHideLimitedStockClearanceEnabled',
  useNewMapPolicy: 'fs:pricing--enableNewMapPolicy',
  isPlpMessagingEnabled: 'fs:promotion--plpPromoMessageEnabled',
  isDailyDealsEnabled: 'fs:pricing--isDailyDealsEnabled',
  isStrikeThroughPricingDisclaimerEnabled: 'fs:pricing--isStrikeThroughPricingDisclaimerEnabled',
  isMapSpecialPriceViolation: 'fs:pricing--isMapSpecialPriceViolation'
});

export const SBOTD_KEY = 'Online Exclusive Special Buy of the Day';
